import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { NewConstraint, PlanningKind, PlanningsData } from './types';

const KEY = ['ref-network-plannings'];
const send = async (url: string, method: string, body?: unknown) =>
    (await (await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: body ? JSON.stringify(body) : undefined })).json()) as PlanningsData;

export function usePlannings() {
    return useQuery({ queryKey: KEY, queryFn: async () => (await (await fetch('/api/ref-network-plannings')).json()) as PlanningsData });
}

export function usePlanningMutations(kind: PlanningKind) {
    const qc = useQueryClient();
    const onSuccess = (data: PlanningsData) => qc.setQueryData(KEY, data);
    return {
        createPlanning: useMutation({ mutationFn: (name: string) => send(`/api/ref-network-plannings/${kind}`, 'POST', { name }), onSuccess }),
        addConstraint: useMutation({
            mutationFn: ({ planningId, constraint }: { planningId: string; constraint: NewConstraint }) =>
                send(`/api/ref-network-plannings/${kind}/${planningId}/constraints`, 'POST', constraint),
            onSuccess,
        }),
        deleteConstraint: useMutation({
            mutationFn: ({ planningId, id }: { planningId: string; id: string }) => send(`/api/ref-network-plannings/${kind}/${planningId}/constraints/${id}`, 'DELETE'),
            onSuccess,
        }),
    };
}
